import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ConfirmationModal, ListingItem } from 'views/components';
import { Container, Text } from './styled';
import React, { useState } from 'react';
import {
    parseSchedule,
    turnsActions
} from 'core/Turns';
import {
    useDispatch,
    useSelector
} from 'hooks';

const AgendaList = ({
    doctorId,
    filter
}) => {

    const dispatch = useDispatch();
    const { dangerColor, textColor, successColor } = useTheme();
    const { push } = useHistory();
    const { t } = useTranslation();

    const {
        user: {
            restricted_access
        }
    } = useSelector('account');
    const schedule = useSelector(parseSchedule);

    const [deleteType, setDeleteType] = useState('');
    const [modalDelete, setModalDelete] = useState(false);
    const [selectedId, setSelectedId] = useState(0);

    const handleClick = (id, mode, type) => {
        if (mode === t('editar')) {
            push(`${ t('/agenda/editar') }/${ id }`);
        } else if (mode === 'eliminar') {
            setDeleteType(type);
            setModalDelete(true);
            setSelectedId(id);
        }
    };

    const onItemDelete = action => {
        if (action === 'confirm') {
            if (deleteType === 'available') {
                dispatch(turnsActions.deleteAvailableTime(selectedId));
            } else if (deleteType === 'unavailable') {
                dispatch(turnsActions.deleteUnavailableTime(selectedId));
            }
        }
        setDeleteType('');
        setModalDelete(false);
        setSelectedId(0);
    };

    const parseName = type => {
        switch (type) {
        case ('agenda'): return t('Agenda');
        case ('available'): return t('Días DISPONIBLES adicionales');
        case ('unavailable'): return t('Días NO DISPONIBLES');
        default: return '-';
        }
    };

    const filteredSchedule = !!filter ? schedule.filter(({ type }) => type === filter) : schedule;
    
    return (
        <Container>
            <ConfirmationModal
                actionHandler={ onItemDelete }
                active={ modalDelete }
                title={ t('¿Quieres eliminar este horario?') }
            />
            {
                !isEmpty(filteredSchedule)
                    ? filteredSchedule.map(({
                        agenda_id,
                        all_day,
                        allow_patient_turn,
                        comment,
                        from_date,
                        from_time,
                        id,
                        office,
                        reason,
                        to_date,
                        to_time,
                        type
                    }, index) => {
                        const itemId = type === 'agenda' ? agenda_id : id;
                        const momentTo = moment(to_date, 'YYYY-MM-DD');
                        const momentFrom = moment(from_date, 'YYYY-MM-DD');
                        const from = momentFrom.format('DD/MM/YYYY');
                        const to = momentTo.format('DD/MM/YYYY');
                        const active = momentTo.diff(moment(), 'days') >= 0 && momentFrom.diff(moment(), 'days') <= 0;
                        const expired = momentTo.diff(moment(), 'days') < 0;
                        const officeName = office ? `${ office.name }: ` : '';
                        const dateRange = from !== to ? `${ t('Desde el') } ${ from } ${ t('hasta el') } ${ to }` : `${ t('El') } ${ from }`;
                        const timeRange = !all_day && from_time && to_time ? `, ${ t('de') } ${ from_time } a ${ to_time }` : '';
                        const reasonText = reason ? ` - ${ reason }` : '';
                        const allowTurnText = !allow_patient_turn && ['agenda'].includes(type) ? ` (${ t('no disponible para pacientes') })` : '';
                        const text = `${ officeName }${ dateRange }${ timeRange }${ reasonText }${ allowTurnText }`;
                        const title = `${ parseName(type) }${ expired ? ` (${ t('Vencido') })` : active ? ` (${ t('Activo') })` : '' }`;
                        return <ListingItem
                            allowDelete={ ['available', 'unavailable'].includes(type) }
                            allowEdit={ ['agenda'].includes(type) && (!!doctorId || !restricted_access) }
                            allowView={ false }
                            hideAvatar={ true }
                            iconColor={ expired ? dangerColor : active ? successColor : textColor }
                            key={ index }
                            reference={ comment }
                            text={ text }
                            title={ title }
                            titleColor={ expired ? dangerColor : active ? successColor : textColor }
                            onActionClick={ mode => handleClick(itemId, mode, type) }
                        />;
                    })
                    : <Text>{ t('No hay elementos disponibles') }</Text>
            }
        </Container>
    );
};

AgendaList.propTypes = {
    doctorId: PropTypes.number,
    filter: PropTypes.string
};

export default AgendaList;
